/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import Pool from './pool';

/**
 * @private
 * @typedef {Record<string, *>} PoolObjectFactory TODO #555
 */

/**
 * Továrna na bazény recyklovaných objektů.
 */
export default class PoolFactory {
  /**
   * Vytvoří nový bazén.
   * @param {PoolObjectFactory} factory Továrna pro vytváření nových objektů umísťených v bazénu.
   * @param {Object} [opts={}] Nepovinné parametry.
   * @param {number} [opts.max=Infinity] Maximální počet objektů, které má bazén vytvořit.
   * @returns {Pool}
   */
  create(factory, { max = Infinity } = {}) {
    return new Pool(factory, max);
  }
}
